module.exports = __webpack_public_path__ + "img/FlashExchange.0cd29833.png";